import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { NGXS_PLUGINS } from '@ngxs/store';
import { environment } from './../../../environments/environment';
import { AuthGuard } from './guards/auth.guard';
import { logoutPlugin } from './plugins/ngxs-plugins';
import { AuthMockService } from './services/auth-mock.service';
import { AuthService } from './services/auth.service';
import { ErrorMappingService } from './services/error-mapping.service';
import { FormService } from './services/form.service';
import { SnackBarService } from './services/snack-bar.service';
import { MAT_SNACK_BAR_DEFAULT_OPTIONS } from '@angular/material/snack-bar';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { RequestErrorsInterceptor } from './interceptors/request-errors.interceptor';
import { RefreshTokenInterceptor } from './interceptors/refresh-token.interceptor';
import { PasswordService } from './services/password.service';
import { PasswordMockService } from './services/password-mock.service';
import { UserService } from './services/user.service';
import { UserMockService } from './services/user-mock.service';
import { IdleMonitorInterceptor } from './interceptors/idle-monitor.interceptor';

@NgModule({
  imports: [CommonModule]
})
export class CoreModule {
  static forRoot(): ModuleWithProviders<CoreModule> {
    return {
      ngModule: CoreModule,
      providers: [
        {
          provide: NGXS_PLUGINS,
          useValue: logoutPlugin,
          multi: true
        },
        // { provide: HTTP_INTERCEPTORS, useClass: RequestErrorsInterceptor, multi: true
        // },
        {
          provide: HTTP_INTERCEPTORS,
          useClass: RefreshTokenInterceptor,
          multi: true
        },
        // Idle Monitor
        {
          provide: HTTP_INTERCEPTORS,
          useClass: IdleMonitorInterceptor,
          multi: true,
        },
        ErrorMappingService,
        FormService,
        AuthGuard,
        {
          provide: MAT_SNACK_BAR_DEFAULT_OPTIONS,
          useValue: { duration: 6000 }
        },
        SnackBarService,
        {
          provide: PasswordService,
          useClass: environment.useMock ? PasswordMockService : PasswordService
        },
        {
          provide: AuthService,
          useClass: environment.useMock ? AuthMockService : AuthService
        },
        {
          provide: UserService,
          useClass: environment.useMock ? UserMockService : UserService
        }
      ]
    };
  }
}
